import { render, staticRenderFns } from "./detail.html?vue&type=template&id=5b8afe3c&scoped=true&external"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8afe3c",
  null
  
)

export default component.exports